import { graphql } from "react-relay";

/////////
// GQL //
/////////

export const fragments = {
  org: graphql`
    fragment AutopilotFlexibility_org on Org {
      userWorkingHours(resolveOverrides: false) {
        workingHours {
          id
          type
          timeZone
          daySettings {
            day
            setting {
              minSlot
              maxSlot
              excludedSlots
            }
          }
          dayOverrides {
            date
            setting {
              minSlot
              maxSlot
              excludedSlots
            }
          }
        }
      }
    }
  `,
  event: graphql`
    fragment AutopilotFlexibility_event on Event {
      eventParentRelayId
      attendeePeople {
        __typename
        ... on PersonList {
          list {
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
          }
        }
      }
      eventKey {
        id
        externalEventId
      }
      annotatedEvent {
        orgTags {
          tag
          state {
            active
            value
            subjectType
            subjectValue
            lastModified
          }
        }
      }
      annotatedRecurringEvent {
        orgTags {
          tag
          state {
            active
            value
            subjectType
            subjectValue
            lastModified
          }
        }
      }
      suggestedAutopilotSettingsResponseV3 {
        __typename
        ... on SuggestedAutopilotSettingsResponseV3 {
          id
          intersectionOfAttendeesMeetingHours {
            minSlot {
              dayOffset
              timeSlot
            }
            maxSlot {
              dayOffset
              timeSlot
            }
          }
          calendarIdToMeetingHours {
            calendarId
            dayOffsetTimeSlotRanges {
              minSlot {
                dayOffset
                timeSlot
              }
              maxSlot {
                dayOffset
                timeSlot
              }
            }
          }
          suggestedAutopilotSettings {
            isRoomFlexible
            movementType
            allowedEndTime {
              dayOffset
              timeSlot
            }
            allowedStartTime {
              dayOffset
              timeSlot
            }
          }
        }
        ... on GraphEntityError {
          message
        }
      }
      moveRangeInLocalTimeV3 {
        __typename
        ... on MoveRangeInLocalTimeV3 {
          allowedStartTimeInclusive {
            dayOffset
            timeSlot
          }
          allowedEndTimeInclusive {
            dayOffset
            timeSlot
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
};
